import { render, staticRenderFns } from "./magazineAnalysis.vue?vue&type=template&id=2ecd69ec"
import script from "./magazineAnalysis.vue?vue&type=script&lang=js"
export * from "./magazineAnalysis.vue?vue&type=script&lang=js"
import style0 from "./magazineAnalysis.vue?vue&type=style&index=0&id=2ecd69ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports